module.exports = __webpack_public_path__ + "img/ins.f049902e.png";